module.exports = __webpack_public_path__ + "media/images/home-alternate-dbd3894da45317b3f5faecc635196e28.svg";